import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTER } from '../router/constants'
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material'

const Home = () => {

  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <div className='container' style={{padding:'60px 40px' , backgroundColor:'white' , borderRadius:'10px' , boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)'}}>
      <Box sx={{ mb: '64px' }}>
        <Typography
          variant={isLargeScreen ? 'h1' : 'h2'}
          align="center"
          color='black'
          fontWeight={700}
          sx={{
            fontWeight: isLargeScreen ? 600 : 700,
            color: 'black',
            mb: '24px'
          }}
        >
          خوش آمديد
        </Typography>
        <Typography
          color={theme.palette.info.dark}
          variant={isLargeScreen ? 'h5' : 'h6'}
          align="center"
        >
          با سامانه هوشمند مديريت رزرو اتاق، تجربه اى سريع، دقيق و بدون دغدغه در برنامه ريزى و مديريت زمان استراحت خود به بهترین وجه داشته باشید
        </Typography>
      </Box>
      <Box sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2
      }}>
        <Box sx={{ width: '50%' }}>
          <Button
            component={Link}
            to={ROUTER.RESERVE_ROOM_DATE}
            fullWidth
            variant="contained"
            sx={{
              height: '48px',
              py: 1.5,
              px: 3,
              borderRadius: 1,
              fontSize: isLargeScreen ? '16px' : '14px',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: 6
              },
              transition: 'all 0.3s'
            }}
          >
            رزرو اتاق
          </Button>
        </Box>
        <Box sx={{ width: '50%' }}>
          <Button
            component={Link}
            to={ROUTER.AUTHENTICATION}
            fullWidth
            variant="outlined"
            sx={{
              height: '48px',
              py: 1.5,
              px: 3,
              borderRadius: 1,
              fontSize: isLargeScreen ? '16px' : '14px',
              color: 'primary.main',
              borderColor: 'primary.main',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: 6,
                borderColor: 'primary.main'
              },
              transition: 'all 0.3s'
            }}
          >
            رزرو کرده ام
          </Button>
        </Box>
      </Box>
    </div>
  )
}

export default Home
